import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import Icon from './Icon';

const directions = {
    up: 'rotate(-90deg)',
    down: 'rotate(90deg)',
    left: 'rotate(-180deg)',
    right: 'rotate(0deg)',
};

const ChevronIcon = styled<any, any>(Icon)`
    transition: transform 150ms ease-in-out;
    transform: ${p => directions[p.direction]};
`;

ChevronIcon.defaultProps = {
    color: "inherit",
    iconSize: "md"
};

interface ChevronProps {
    theme?: { [property: string]: string | number };
    fileName?: string;
    direction?: 'up' | 'down' | 'left' | 'right';
}

export const Chevron: React.SFC<ChevronProps> = ({ theme, fileName = 'ChevronRightIcon', direction = 'right', ...props }) => (
    <ChevronIcon 
        fileName={fileName}
        direction={direction}
        {...props}
        {...theme.Chevron}
    />
);

export default withTheme(observer(Chevron)) as any;


// WEBPACK FOOTER //
// ./src/Components/Chevron.tsx